export interface Competency {
  id: string
  index: string
  title: string
  summary: string
  points: string[]
}

export const competencies: Competency[] = [
  {
    id: 'product-strategy',
    index: 'I',
    title: 'Enterprise Product Strategy & AI Modernization',
    summary:
      'Transforming legacy SaaS into AI-enabled, data-driven platforms with governance that holds at enterprise scale.',
    points: [
      'Roadmapping and multi-year platform strategy aligned to board-level growth targets.',
      'Cloud-first transitions across AWS, Big Data and Hadoop architectures.',
      'Product lifecycle governance from concept through sunset across global portfolios.',
    ],
  },
  {
    id: 'gtm',
    index: 'II',
    title: 'Go-to-Market & Monetization Optimization',
    summary:
      'Re-engineering pricing and packaging frameworks to maximize average selling price and net retention.',
    points: [
      'Pricing and packaging redesign lifting ASP and expansion revenue.',
      'Formal 0-to-1 GTM launch frameworks adopted company-wide.',
      'Initial deal pipelines in the 6- and 7-figure range within the first cycles.',
    ],
  },
  {
    id: 'ma',
    index: 'III',
    title: 'M&A, Due Diligence & PE Advisory',
    summary:
      'Partnering with bankers, sponsors and boards through diligence, positioning and exit readiness.',
    points: [
      'Confidential Information Memorandum authorship supporting strategic sale processes at Harte Hanks, Information Builders and Accelerate Learning.',
      'Technical due diligence leadership on international acquisitions, including Kide Science.',
      'Post-merger integration of product organizations, roadmaps and pricing models.',
    ],
  },
  {
    id: 'governance',
    index: 'IV',
    title: 'Customer-Centric Scale & Governance',
    summary:
      'Institutionalizing the customer voice as a measurable revenue engine, not a listening exercise.',
    points: [
      'Design and scale of global Customer Advisory Boards yielding multi-million-dollar incremental revenue.',
      'Leadership of global, cross-functional teams of 20+ product managers, product owners, UX and engineering leaders.',
      'Operating cadences that connect customer insight directly to roadmap and pricing decisions.',
    ],
  },
]
